import { c as _c } from "react/compiler-runtime";
import { useSecurityLoading } from '@/context/SecurityLoadingContext';
import { useRouter } from 'next/router';
import { ReactNode, useEffect } from 'react';
import { isPathInRoutes } from '../utils/guard-utils';
type BaseGuardProps = {
  children: ReactNode;
  /** Unique identifier for this guard instance (used for unified loading tracking) */
  guardId: string;
  isLoading: boolean;
  shouldAllowAccess: boolean;
  freeRoutes: readonly string[];
};
const BaseGuard = t0 => {
  const $ = _c(7);
  const {
    children,
    guardId,
    isLoading,
    shouldAllowAccess,
    freeRoutes
  } = t0;
  const router = useRouter();
  const {
    registerLoader
  } = useSecurityLoading();
  const isFreeRoute = isPathInRoutes(router.pathname, freeRoutes);
  let t1;
  let t2;
  if ($[0] !== guardId || $[1] !== isLoading || $[2] !== registerLoader) {
    t1 = () => {
      registerLoader(guardId, isLoading);
    };
    t2 = [guardId, isLoading, registerLoader];
    $[0] = guardId;
    $[1] = isLoading;
    $[2] = registerLoader;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (isLoading) {
    return null;
  }
  if (!shouldAllowAccess && !isFreeRoute) {
    return null;
  }
  let t3;
  if ($[5] !== children) {
    t3 = <>{children}</>;
    $[5] = children;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export { BaseGuard };